import React from 'react';
export function AttentionBanner() {
  return <div className="fixed top-[32px] left-0 right-0 z-40 h-[36px] bg-deepBlue/90 backdrop-blur-sm flex items-center justify-center px-4 border-b border-goldenYellow/30" data-id="element-12">
      <p className="text-xs md:text-sm text-center font-semibold tracking-wide" data-id="element-13">
        <span className="text-goldenYellow" data-id="element-14">📣</span>
        <span className="text-white/90 ml-2" data-id="element-15">
          Atención estudiantes universitarios:
        </span>
        <span className="text-goldenYellow font-bold ml-1" data-id="element-16">
          esto es para vos
        </span>
      </p>
    </div>;
}